export default "__VITE_ASSET__mUK51iP9__"